import React from 'react'
import { Collapse, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ActionButton } from '@emerald-works-nova/components'
import { useDispatch, useSelector } from 'react-redux'
import { PermissionsUploadSlice } from '../../../../reducers'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    marginBottom: spacing(2),
    paddingBlock: spacing(3),
    paddingInline: spacing(4),
    background: palette.grey.lighter,
    border: `1px dashed ${palette.grey.dark}`,
    borderRadius: 4
  }
}))

const PermissionsUploadResults = () => {
  const classes = useStyles()
  const results = useSelector(PermissionsUploadSlice.selectors.selectResults)
  const reportUrl = useSelector(PermissionsUploadSlice.selectors.selectReportUrl)
  const dispatch = useDispatch()

  const handleDismiss = () => {
    dispatch(PermissionsUploadSlice.actions.reset())
  }

  return (
    <Collapse in={!!results}>
      {results && (
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          className={classes.root}
          data-test='permissions-upload-report'
        >
          <Grid item xs>
            <Typography variant='caption'>
              <strong>
                Permissions Update Finished
              </strong>
              <br />
              <strong>
                {new Date().toLocaleDateString()} - Permissions Update Log
              </strong>
              <br />
              Total number of records on file: {results.totalCount}
              <br />
              Failed records: {results.errorCount}
              <br />
              Total users updated: {results.successCount}
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            container
            direction='column'
            alignItems='flex-end'
            spacing={2}
          >
            <Grid item>
              <ActionButton
                text='Dismiss'
                noBorder
                onClick={handleDismiss}
                data-test='permissions-upload-dismiss-button'
              />
            </Grid>
            <Grid item>
              <ActionButton
                text='Download CSV File'
                component='a'
                href={reportUrl}
                target='_blank'
                disabled={!reportUrl}
                data-test='permissions-upload-download-report-button'
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Collapse>
  )
}

export default PermissionsUploadResults
